import React from "react";
import { useCartStore } from "../../stores/CartStore";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { observer } from "mobx-react-lite";

const CrossSellDialog = observer(() => {
    const cartStore = useCartStore();

    if (!cartStore) return null;

    const crossSell = cartStore.crossSellNode;

    return (
        <Dialog open={cartStore.showCrossSellDialog} maxWidth="md">
            <DialogTitle>Promo</DialogTitle>
            <DialogContent>{crossSell?.message}</DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => (location.href = crossSell!.link)}
                >
                    Yes
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => cartStore.hideCrossSellDialog()}
                >
                    No Thanks
                </Button>
            </DialogActions>
        </Dialog>
    );
});

export default CrossSellDialog;
